import React from 'react';
import {
  Box,
  Typography,
  Modal,
  IconButton,
  useTheme,
  useMediaQuery,
  Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconReusable from '../../../components/IconReusable';

const GlassModal = ({
  open,
  onClose,
  title = '',
  subtitle = '',
  children,
  maxWidth = '800px',
  topDesktop = '50%',
  topMobile = '20%',
  scrollable = true,
  maxHeight = '20%',
  desktopHeight = 'auto',
  pt = 2,
  zIndex = 2,
  showHeader = true,
  padding = true,
  keepMounted = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const modalContent = (
    
    <Box
      sx={{
        position: 'fixed',
        bottom: isMobile ? 0 : 'auto',
        left: isMobile ? 0 : '50%',
        right: isMobile ? 0 : 'auto',
        top: isMobile ? 'auto' : topDesktop,
        transform: isMobile ? 'none' : 'translate(-50%, -50%)',
        width: isMobile ? '100%' : maxWidth,
        height: isMobile ? 'auto' : 'auto',
        maxHeight: isMobile ? '90vh' : '80vh',
        backgroundColor: !isMobile ? '#ffffff45' : 'transparent',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: isMobile ? 0 : 16,
        borderBottomRightRadius: isMobile ? 0 : 16,
        boxShadow: 24,
        display: 'flex',
        flexDirection: 'column',
        overflowY: isMobile ? 'visible' : 'unset',
        zIndex: 1301,
      }}
    >
       <Box
          sx={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: -1,
            left: 0,
            borderRadius: 2,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.05) 100%)',
            backgroundBlendMode: 'overlay',
            zIndex: 0,
            opacity: 0.6,
            // border: '.5px solid rgba(255,255,255, 0.2)',
          }}
        />
        <Box
          sx={{
            width:'100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            borderRadius: 2,
            borderBottomLeftRadius: isMobile ? 0 : 16,
            borderBottomRightRadius: isMobile ? 0 : 16,
            backgroundColor: !isMobile ? 'rgba(0, 0, 0, 0)' : '#ffffff7a',
            backdropFilter: 'blur(2px)',
            WebkitBackdropFilter: 'blur(2px)',
            boxShadow: `
              inset 1px 1px 4px 0px rgba(255, 255, 255, 0.6),
              inset 1px 1px 0px 0px rgba(255, 255, 255, 1),
              inset 10px 0px 20px 0px rgba(0, 0, 0, 0.05),
              inset 1px 4px 40px 1px rgba(255, 255, 255, 1),
              inset 0px 2px 16px 1px rgba(255, 255, 255, 1),
              inset 0px -2px 0px 0px rgba(255, 255, 255, 1),
              inset -1px -4px 16px 0px rgba(255, 255, 255, 0.8)
            `,
            zIndex: 1,
            
          }}
        />
     
      {showHeader &&
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            py: 2,
            px: { md: 2, xs: 2 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            zIndex: 1,
            borderBottom: '1px solid #D9D9D9',
            outlineOffset: '-1px',
            boxShadow: '0px 2px 8px 0px #0000001A'
          }}
        >
          
          <Typography variant="h1">{title}</Typography>
          {onClose && (
            <Box sx={{ cursor: 'pointer', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Box sx={{ cursor: 'pointer', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <IconReusable name="Close" onClick={onClose} color='#333'  width={'24px'} height={'24px'}/>
              </Box>
            </Box>
          )}
        </Box>
      }

      {subtitle && (
        <Box sx={{ px: { md: 4, xs: 2 }, pb: 1 }}>
          <Typography variant="body1">{subtitle}</Typography>
        </Box>
      )}

      <Box
        sx={{

          pt: padding ? 2 : 0 ,
          px: padding? { md: 2, xs: 2 } : 0,
          pb: { xs: 2, md: 2},
          overflowY: scrollable ? 'auto' : 'unset',
          flex: 1,
          position: 'relative',
          zIndex: zIndex,
        }}
      >
        
        {children}
        
      </Box>
    </Box>
  );

  return (
    <Modal open={open} onClose={onClose} keepMounted={keepMounted}>
      {isMobile ? (
        <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={{ enter: 500, exit: 300 }}>
          {modalContent}
        </Slide>
      ) : (
        modalContent
      )}
    </Modal>
  );
};

export default GlassModal;
